module.exports = __webpack_public_path__ + "1f8b71d990e3856ce52ba58547ddba17.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/footer/image-4.jpg
// module id = ./assets/images/footer/image-4.jpg
// module chunks = 0